export const isNativeDiagnosticsAvailable = false

export type NativeDiagnosticsExportResult = 'cancelled' | 'saved' | 'shared'

export function installNativeDiagnostics() {}

export async function exportNativeDiagnostics(): Promise<NativeDiagnosticsExportResult> {
  throw new Error('Native diagnostics are unavailable on web.')
}

export async function getNativeDiagnosticsForClipboard(): Promise<string> {
  throw new Error('Native diagnostics are unavailable on web.')
}
